import { useState } from 'react'

import brandIcon from '@/assets/brand_icon.png'
import { cn } from '@/lib/cn'

/// Порт `AppBrandIcon`: если картинка не загрузилась, на её месте остаётся
/// фирменный квадрат с «K», а не битый значок.
export function BrandIcon({
  size,
  radius,
  className,
}: {
  size: number
  radius?: number
  className?: string
}) {
  const [failed, setFailed] = useState(false)
  const borderRadius = radius ?? size * 0.25

  if (failed) {
    return (
      <span
        className={cn('flex shrink-0 items-center justify-center bg-brand font-extrabold text-white', className)}
        style={{ width: size, height: size, borderRadius, fontSize: size * 0.42 }}
      >
        K
      </span>
    )
  }

  return (
    <img
      src={brandIcon}
      alt=""
      width={size}
      height={size}
      onError={() => setFailed(true)}
      className={cn('shrink-0 object-cover', className)}
      style={{ width: size, height: size, borderRadius }}
    />
  )
}
